<template>
    <div>
        <v-dialog
            v-model="visible"
            :fullscreen="fullscreen"
            height="1000"
            :width="dialogWidth"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        >{{ mode }}: {{ symbolLogin }}
                        {{
                            $t("monitor.home.symbolDetailDialog.detail")
                        }}</v-toolbar-title
                    >

                    <v-spacer></v-spacer>
                    <template
                        v-if="!VUETIFY_BREAKPOINT.mobile && allowDownloadAll"
                    >
                        <v-btn
                            small
                            dark
                            color="primary"
                            dense
                            class="mr-1"
                            :loading="allSymbolDownloadLoading"
                            @click="downloadAllSymbolSnapshot"
                            >{{
                                $t(
                                    "monitor.home.symbolDetailDialog.downloadAll"
                                )
                            }}</v-btn
                        >
                    </template>
                    <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-if="!VUETIFY_BREAKPOINT.mobile"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                class="mr-2"
                                style="display: block; float: right"
                                @click="startTutorial"
                                >mdi-school</v-icon
                            >
                        </template>
                        <span>{{
                            $t("common.phrase.clickToStartTutorial")
                        }}</span>
                    </v-tooltip>
                    <v-btn
                        v-if="!VUETIFY_BREAKPOINT.mobile"
                        color="white"
                        icon
                        @click="toggleFullscreen"
                    >
                        <v-icon>mdi-arrow-expand</v-icon>
                    </v-btn>
                    <v-btn color="white" icon @click="handleClose">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-tabs v-model="tab" id="symbolTabChanging">
                    <v-tab v-on:click="changeView('trades')"
                        >{{
                            mode === "Symbol"
                                ? $t("monitor.home.symbolDetailDialog.trades")
                                : $t("monitor.home.symbolDetailDialog.detail")
                        }}
                    </v-tab>
                    <v-tab
                        v-on:click="changeView('snapshot')"
                        v-if="
                            showSymbolSnapshot &&
                            isNotIBPage &&
                            mode === 'Symbol' &&
                            selectedBook
                        "
                    >
                        {{
                            $t("monitor.home.symbolDetailDialog.symbolSnapshot")
                        }}
                    </v-tab>
                    <v-tab
                        v-on:click="changeView('positionChart')"
                        v-if="mode === 'Symbol' && selectedBook"
                    >
                        {{
                            $t("monitor.home.symbolDetailDialog.positionChart")
                        }}
                    </v-tab>
                </v-tabs>
                <template v-if="loadTrades">
                    <!-- PK副表的搜索 -->
                    <v-text-field
                        class="mr-4 mt-n2 ml-4 1mb-5"
                        v-model="searchLogin"
                        append-icon="mdi-search"
                        :label="
                            mode === 'Login'
                                ? $t(
                                      'monitor.home.symbolDetailDialog.searchSymbol'
                                  )
                                : $t(
                                      'monitor.home.symbolDetailDialog.searchLogin'
                                  )
                        "
                        single-line
                        hide-details
                        id="symbolTabSearch"
                    >
                    </v-text-field>

                    <!-- PK表副表逻辑 -->
                    <v-data-table
                        id="symbolDetailTable"
                        dense
                        :search="searchLogin"
                        :headers="subHeader"
                        :items="computedSymbolDetailObject"
                        :loading="tableLoading"
                        item-key="login"
                        :items-per-page="15"
                        fixed-header
                        :customSort="customSort"
                        :header-props="{ sortIcon: null }"
                        :mobile-breakpoint="0"
                        :class="{
                            'fix-first-col': VUETIFY_BREAKPOINT.mobile,
                        }"
                        class="no-break"
                        :footer-props="{
                            itemsPerPageOptions: [10, 15],
                            'items-per-page-text': '',
                        }"
                        v-sortable-table="{
                            onEnd: sortSubHeadersAndUpdateTheKey,
                        }"
                        :key="anIncreasingNumberForSub"
                    >
                        <template v-slot:header.longPositions="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>

                        <template v-slot:header.shortPositions="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.dailyNet="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.floatingProfitEOD="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.closedProfitEOD="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.exposure="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.floatingProfit="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.closedProfit="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:header.dailyVolumeUSD="{ header }">
                            {{ header.text }}
                            <v-icon
                                size="18"
                                color="orange"
                                style="position: absolute"
                                v-if="showSumUp"
                                @click.stop="
                                    () =>
                                        calculateTooltipNumber(
                                            header.text,
                                            header.value
                                        )
                                "
                                >mdi-calculator</v-icon
                            >
                        </template>
                        <template v-slot:item.login="{ item }">
                            <div>
                                <span
                                    :class="{
                                        'link-text': showHomeLoginDetailSummary,
                                    }"
                                    @click.stop="handleLoginClick(item)"
                                    :style="{ whiteSpace: 'nowrap' }"
                                >
                                    {{ item.login }}
                                </span>
                                <span>
                                    <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="rowClicked(item)"
                                                class="pl-1"
                                                >mdi-card-account-details</v-icon
                                            >
                                        </template>
                                        <span>
                                            {{
                                                $t(
                                                    "monitor.home.symbolDetailDialog.show"
                                                )
                                            }}
                                            {{
                                                mode === "Symbol"
                                                    ? "Login"
                                                    : mode
                                            }}
                                            {{
                                                $t(
                                                    "monitor.home.symbolDetailDialog.detail"
                                                )
                                            }}
                                        </span>
                                    </v-tooltip></span
                                >
                            </div>

                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        v-show="item.isInPercentageMode"
                                        >mdi-brightness-percent</v-icon
                                    >
                                </template>
                                <span>{{
                                    $t(
                                        "monitor.home.symbolDetailDialog.percentHedge"
                                    )
                                }}</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </template>

                <SnapshotTab
                    v-if="loadSnapshot && mode === 'Symbol'"
                    target="symbol"
                    :book="selectedBook"
                    :symbol="symbolLogin"
                />

                <PositionChart
                    v-if="loadPositionChart && mode === 'Symbol'"
                    :book="selectedBook"
                    :symbol="symbolLogin"
                />

                <v-card-actions />
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogSumUp"
            height="300"
            width="500"
            v-if="showSumUp"
            :hide-overlay="false"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">{{
                        $t("monitor.home.symbolDetailDialog.sumUpResult")
                    }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn
                        color="white"
                        icon
                        @click="
                            () => {
                                dialogSumUp = false;
                            }
                        "
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>
                <div v-html="htmlResult" class="pa-4"></div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import deepClone from "deep-clone";
import SnapshotTab from "./ComponentSnapshotTab";
import introJs from "intro.js";
import { TutorialConstant } from "@assets/tutorialConstant";
import { snackbar } from "@components/mixins/snackbar";
import dayjs from "dayjs";
import PositionChart from "./ComponentPositionChart";
import { redirectToRH } from "@utils/util";

export default {
    name: "SymbolDetailDialog",
    mixins: [snackbar],
    components: {
        SnapshotTab,
        PositionChart,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        symbolLogin: {
            type: String,
            default: "",
        },
        symbolLoginDetailArray: {
            type: Array,
            default: () => [],
        },
        showHomeLoginDetailSummary: {
            type: Boolean,
            default: false,
        },
        tableLoading: {
            type: Boolean,
            default: false,
        },
        selectedBook: {
            type: String,
            default: "",
        },
        mode: {
            type: String,
            default: "Symbol",
        },
    },
    data() {
        return {
            tutorialConstant: TutorialConstant,
            tab: "trades",
            dialogSumUp: false,
            searchLogin: "",
            fullscreen: false,
            anIncreasingNumberForSub: 1,
            subHeader: null,
            showSumUp: false,
            htmlResult: "",
            showSymbolSnapshot: false,
            loadSnapshot: false,
            loadTrades: true,
            loadPositionChart: false,
            dialogWidth: 1200,
            allSymbolDownloadLoading: false,
            allowDownloadAll: false,
        };
    },
    computed: {
        ...mapState("Home", [
            "subTableHeader",
            "homeSymbolTutorial",
            "homeSymbolSnapshotTutorial",
            "subLoginTableHeader",
        ]),
        ...mapState("SettingsServer", ["serverData"]),
        computedSymbolDetailObject() {
            if (this.searchLogin && this.symbolLoginDetailArray) {
                return this.symbolLoginDetailArray.filter((item) =>
                    this.mode === "Symbol"
                        ? item.login
                              .toUpperCase()
                              .includes(this.searchLogin.toUpperCase())
                        : item.symbol
                              .toUpperCase()
                              .includes(this.searchLogin.toUpperCase())
                );
            }
            return this.symbolLoginDetailArray;
        },
        isNotIBPage() {
            return this.$route.path !== "/ib-monitor";
        },
    },
    watch: {
        visible(val) {
            if (!val) {
                this.$nextTick(() => {
                    this.searchLogin = "";
                    if (!this.VUETIFY_BREAKPOINT.mobile) {
                        this.fullscreen = false;
                    }
                });
            } else {
                this.changeView("trades");
            }
        },
        "VUETIFY_BREAKPOINT.mobile": {
            immediate: true,
            handler(val) {
                if (val) {
                    this.fullscreen = true;
                }
            },
        },
        homeSymbolTutorial(nv) {
            if (!!nv) {
                this.getSymbolTutorial()
                    .oncomplete(() =>
                        this.updateHomeSymbolTutorialAction(false)
                    )
                    .onexit(() => this.updateHomeSymbolTutorialAction(false))
                    .start();
            }
        },
        homeSymbolSnapshotTutorial(nv) {
            if (!!nv) {
                this.getSnapshotTutorial()
                    .oncomplete(() =>
                        this.updateHomeSymbolSnapshotTutorialAction(false)
                    )
                    .onexit(() =>
                        this.updateHomeSymbolSnapshotTutorialAction(false)
                    )
                    .start();
            }
        },
        mode(nv, ov) {
            if (nv !== ov) {
                this.subHeader = deepClone(
                    this.mode === "Symbol"
                        ? this.subTableHeader
                        : this.subLoginTableHeader
                );
                localStorage.setItem(
                    "subHeader",
                    JSON.stringify(
                        this.mode === "Symbol"
                            ? this.subTableHeader
                            : this.subLoginTableHeader
                    )
                );
            }
        },
    },
    mounted() {
        const userFunction = JSON.parse(localStorage.getItem("permission"))
            ?.frontPermission?.book?.function;
        if (userFunction.includes("devSumUp")) {
            this.showSumUp = true;
        }
        if (userFunction.includes("symbolSnapshot")) {
            this.showSymbolSnapshot = true;
        }

        const localSavedSubHeader = localStorage.getItem("subHeader");
        if (localSavedSubHeader) {
            this.subHeader = JSON.parse(localSavedSubHeader);
        } else {
            this.subHeader = deepClone(
                this.mode === "Symbol"
                    ? this.subTableHeader
                    : this.subLoginTableHeader
            );
        }
        if (userFunction.includes("allowDownloadAll")) {
            this.allowDownloadAll = true;
        }
    },
    methods: {
        ...mapActions("Home", [
            "updateHomeSymbolTutorialAction",
            "updateHomeSymbolSnapshotTutorialAction",
        ]),
        startTutorial() {
            if (this.tab == 0) {
                this.updateHomeSymbolTutorialAction(true);
            }
            if (this.tab == 1) {
                this.updateHomeSymbolSnapshotTutorialAction(true);
            }
        },
        async requestAllSymbolDownload(params) {
            try {
                let url;
                if (process.env.NODE_ENV === "development") {
                    url = "/api/v1/statistic/download-all-symbol-snapshot";
                } else {
                    url =
                        document.querySelector("body").getAttribute("apiurl") ||
                        process.env.VUE_APP_ENDPOINT;
                    url =
                        url + "/api/v1/statistic/download-all-symbol-snapshot";
                }
                const response = await fetch(url, {
                    method: "POST",
                    body: JSON.stringify(params),
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                // Check if the response is ok
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                return response; // This should be a Response object
            } catch (error) {
                console.error("Error in requestAllSymbolDownload:", error);
                throw error;
            }
        },
        downloadAllSymbolSnapshot() {
            this.allSymbolDownloadLoading = true;
            this.snackBarSuccess(
                this.$t("monitor.home.symbolDetailDialog.downloadRequestSent")
            );
            const timeNow = dayjs()
                .tz("US/Eastern")
                .add(7, "hour")
                .add(-1, "minute")
                .format("YYYY_MM_DD HH_mm_00");

            const params = {
                request_time: timeNow,
                selected_symbol: this.symbolLogin,
            };
            this.requestAllSymbolDownload(params)
                .then(async (res) => {
                    if (res && typeof res.blob === "function") {
                        const blob = await res.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download =
                            "Symbol Summary (" +
                            this.symbolLogin +
                            ")- " +
                            timeNow +
                            ".xlsx";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    } else {
                        throw new Error("The response is not a valid Blob");
                    }
                    this.allSymbolDownloadLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.allSymbolDownloadLoading = false;
                    this.snackBarDanger(
                        this.$t(
                            "monitor.home.symbolDetailDialog.downloadRequestFailed"
                        )
                    );
                });
        },
        getSymbolTutorial() {
            return introJs().setOptions({
                steps: [
                    {
                        element: document.getElementById("symbolTabChanging"),
                        title: this.tutorialConstant["homeSymbolDialog"][
                            "symbolTabChanging"
                        ]["title"],
                        intro: this.tutorialConstant["homeSymbolDialog"][
                            "symbolTabChanging"
                        ]["intro"],
                    },
                    {
                        element: document.getElementById("symbolTabSearch"),
                        title: this.tutorialConstant["homeSymbolDialog"][
                            "symbolTabSearch"
                        ]["title"],
                        intro: this.tutorialConstant["homeSymbolDialog"][
                            "symbolTabSearch"
                        ]["intro"],
                    },
                    {
                        element: document.getElementById("symbolDetailTable"),
                        title: this.tutorialConstant["homeSymbolDialog"][
                            "symbolDetailTable"
                        ]["title"],
                        intro: this.tutorialConstant["homeSymbolDialog"][
                            "symbolDetailTable"
                        ]["intro"],
                    },
                ],
                nextLabel: this.$t("tutorial.next"),
                prevLabel: this.$t("tutorial.prev"),
            });
        },
        getSnapshotTutorial() {
            return introJs().setOptions({
                steps: [
                    {
                        element: document.getElementById(
                            "symbolTabTimeSelection"
                        ),
                        title: this.tutorialConstant[
                            "homeSymbolSnapshotDialog"
                        ]["symbolTabTimeSelection"]["title"],
                        intro: this.tutorialConstant[
                            "homeSymbolSnapshotDialog"
                        ]["symbolTabTimeSelection"]["intro"],
                    },
                    {
                        element: document.getElementById(
                            "symbolTabSnapshotTable"
                        ),
                        title: this.tutorialConstant[
                            "homeSymbolSnapshotDialog"
                        ]["symbolTabSnapshotTable"]["title"],
                        intro: this.tutorialConstant[
                            "homeSymbolSnapshotDialog"
                        ]["symbolTabSnapshotTable"]["intro"],
                    },
                ],
            });
        },
        calculateTooltipNumber(title, type) {
            const sum = this.computedSymbolDetailObject.reduce(
                (total, currentValue) =>
                    total +
                    parseFloat(
                        typeof currentValue[type] === "string"
                            ? currentValue[type].replaceAll(",", "")
                            : currentValue[type]
                    ),
                0
            );
            this.htmlResult =
                "<h1 class='mb-2'>" + title + ": " + sum.toFixed(2) + "</h1>";
            this.dialogSumUp = true;
            return;
        },
        handleClose() {
            this.$emit("update:visible", false);
        },
        toggleFullscreen() {
            this.fullscreen = !this.fullscreen;
        },
        sortSubHeadersAndUpdateTheKey(evt) {
            const headersTmp = this.subHeader;
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            if (newIndex >= headersTmp.length) {
                let k = newIndex - headersTmp.length + 1;
                while (k--) {
                    headersTmp.push(undefined);
                }
            }
            headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);
            localStorage.setItem("subHeader", JSON.stringify(headersTmp));
            this.anIncreasingNumberForSub += 1;
        },
        handleLoginClick(item) {
            const serverId = this.serverData.find(
                (server) => server.server_name === item.login.split(":")[0]
            ).id;
            const login = item.login.split(":")[1];
            const url = `/tag-centre/account-analysis/${serverId}-${login}`;
            redirectToRH(url);
        },
        customSort(items, sortBy, sortDesc) {
            items.sort((a, b) => {
                if (sortBy[0] === "exposure") {
                    if (!sortDesc[0]) {
                        return (
                            Math.abs(a[sortBy[0]].replaceAll(",", "")) -
                            Math.abs(b[sortBy[0]].replaceAll(",", ""))
                        );
                    }
                    if (sortDesc[0]) {
                        return (
                            Math.abs(b[sortBy[0]].replaceAll(",", "")) -
                            Math.abs(a[sortBy[0]].replaceAll(",", ""))
                        );
                    }
                } else if (sortBy[0] === "login") {
                    if (!sortDesc[0]) {
                        return a[sortBy] < b[sortBy] ? -1 : 1;
                    } else {
                        return b[sortBy] < a[sortBy] ? -1 : 1;
                    }
                } else if (sortBy[0] === "symbol") {
                    if (!sortDesc[0]) return a.symbol.localeCompare(b.symbol);
                    if (sortDesc[0]) return b.symbol.localeCompare(a.symbol);
                } else {
                    if (!sortDesc[0]) {
                        return (
                            a[sortBy]?.toString().replaceAll(",", "") -
                            b[sortBy]?.toString().replaceAll(",", "")
                        );
                    }
                    if (sortDesc[0]) {
                        return (
                            b[sortBy]?.toString().replaceAll(",", "") -
                            a[sortBy]?.toString().replaceAll(",", "")
                        );
                    }
                }
            });
            return items;
        },
        changeView(tab) {
            this.loadSnapshot = false;
            this.loadTrades = false;
            this.loadPositionChart = false;
            if (tab === "snapshot") {
                this.loadSnapshot = true;
                this.dialogWidth = 800;
            }
            if (tab === "trades") {
                this.loadTrades = true;
                this.dialogWidth = 1400;
            }
            if (tab === "positionChart") {
                this.loadPositionChart = true;
                this.dialogWidth = 1200;
            }
            this.tab = tab;
        },
        rowClicked(data) {
            this.$emit("login-click", data);
        },
    },
};
</script>
<style lang="scss" scoped>
.link-text {
    color: #2196f3;
    cursor: pointer;
    text-decoration: underline;
}
.no_break {
    white-space: nowrap;
}
</style>
